// src/pages/conversaciones/ConversacionChatPage.tsx
import { useParams } from 'react-router-dom';
import { useConversacion, useMensajes, useMarcarLeidos } from '@/hooks/queries/useConversaciones';
import { PageLoader } from '@/components/ui';
import { ChatHeader } from './components/ChatHeader';
import { ChatMessages } from './components/ChatMessages';
import { ChatInput } from './components/ChatInput';
import { ChatSidebar } from './components/ChatSidebar';
import { useEffect } from 'react';

export function ConversacionChatPage() {
  const { id } = useParams<{ id: string }>();
  const { data: conversacion, isLoading: loadingConv } = useConversacion(id);
  const { data: mensajes, isLoading: loadingMsgs } = useMensajes(id);
  const marcarLeidos = useMarcarLeidos();

  // Marcar como leidos al abrir
  useEffect(() => {
    if (id && conversacion && (conversacion.no_leidos_count ?? 0) > 0) {
      marcarLeidos.mutate(id);
    }
  }, [id, conversacion?.no_leidos_count]);

  if (loadingConv) return <PageLoader message="Cargando conversacion..." />;
  if (!conversacion) {
    return (
      <div className="flex items-center justify-center h-96">
        <p className="text-gray-500">Conversacion no encontrada</p>
      </div>
    );
  }

  return (
    <div className="h-[calc(100vh-120px)] flex">
      {/* Area principal de chat */}
      <div className="flex-1 flex flex-col bg-white rounded-lg shadow-sm mr-4">
        <ChatHeader conversacion={conversacion} />
        <ChatMessages mensajes={mensajes ?? []} isLoading={loadingMsgs} />
        <ChatInput conversacionId={id!} disabled={conversacion.estado === 'CERRADA'} />
      </div>

      {/* Panel lateral */}
      <ChatSidebar conversacion={conversacion} />
    </div>
  );
}
